import React from 'react';
import { Helmet } from 'react-helmet-async';
import { landingPages } from '@/content/pages';
import { renderHub } from '@/lib/landingFormat';

const Industries = () => (
  <div className="min-h-screen pt-16 bg-gradient-to-b from-white to-slate-100 dark:from-slate-900 dark:to-slate-950">
    <Helmet>
      <title>Industries We Serve: Websites, Google Ads & AI | Omnicraft</title>
      <meta name="description" content="How Omnicraft builds websites, runs Google Ads and automates work for US small businesses, from dental practices and law firms to plumbers and restaurants." />
    </Helmet>
    <div
      className="container-custom py-12 max-w-3xl mx-auto prose prose-lg prose-slate dark:prose-invert prose-a:text-primary"
      dangerouslySetInnerHTML={{ __html: renderHub('industries', landingPages) }}
    />
  </div>
);

export default Industries;
